<template>
  <div v-if="this.userLogin.company_id != 0">
    <v-card elevation="2">
      <v-card-title>
        List Topik Notifikasi
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px" persistent>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" small dark class="mb-2" v-on="on"
              >Add New</v-btn
            >
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row width="100%">
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field
                      v-model="newTopic.topic"
                      label="Topik"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="12" style="padding:0;">
                    <v-checkbox
                      v-model="newTopic.is_default"
                      :label="`Set as default`"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" v-if="newTopic" text @click="save"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-data-table :headers="headers" :items="topics" class="elevation-1">
        <!-- <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>List Topik Notifikasi</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px" persistent>
              <template v-slot:activator="{ on }">
                <v-btn color="primary" small dark class="mb-2" v-on="on"
                  >Add New</v-btn
                >
              </template>
            </v-dialog>
          </v-toolbar>
        </template> -->
        <template v-slot:[`item.notification_topics`]="{ item }">
          {{ item.notification_topics.substr(0, 50) }}...
          <span @click="copyTestingCode(item.notification_topics)"
            ><md-icon style="cursor: pointer;">content_copy</md-icon></span
          >
        </template>
        <template v-slot:[`item.is_default`]="{ item }">
          <span>{{ item.is_default === 1 ? "YES" : "NO" }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-icon small @click="editItem(item)">edit</v-icon>
          <v-icon color="red" small @click="deleteItem(item)">delete</v-icon>
        </template>
        <template v-slot:no-data>
          <span class="text-center">No data available.</span>
        </template>
      </v-data-table>
      <!-- <div style="padding:20px;" class="d-flex">
        <v-col class="d-flex" cols="12" sm="1">
          <small style="margin-top:30px;">Item show</small>
        </v-col>
        <v-col class="d-flex" cols="12" sm="1">
          <v-select
            v-model="pageSize"
            :items="pageSizes"
            @change="handlePageSizeChange"
            style="font-size:10px;"
          ></v-select>
        </v-col>
        <v-col class="d-flex" cols="12" sm="12">
          <v-pagination
            style="width:auto;"
            v-model="currentPage"
            :length="totalPages"
            total-visible="10"
            next-icon="mdi-menu-right"
            prev-icon="mdi-menu-left"
            @input="handlePageChange"
          ></v-pagination>
          <small style="margin-top:28px;"
            >{{ from }}-{{ to }} of {{ totalData }}</small
          >
        </v-col>
      </div> -->
    </v-card>
  </div>
  <div v-else class="content">
    <div class="md-layout">
      <nav-tabs-card>
        <template slot="content">
          <h3 class="text-center">
            Silahkan tambahkan data company profile terlebih dahulu
          </h3>
        </template>
      </nav-tabs-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import { NavTabsCard } from "@/components";
import { userHaveRoles } from "@/services/utilities";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { formatCurrency } from "@/libs/number";
import dayjs from "dayjs";

export default {
  components: {
    NavTabsCard,
  },
  data: () => ({
    dialog: false,
    dialogVerify: false,
    headers: [
      {
        text: "Topik",
        align: "left",
        value: "topic",
      },
      { text: "is Default", value: "is_default" },
      { text: "Actions", value: "action", sortable: false },
    ],
    topics: [],
    roles: [],
    inputSearch: null,
    newTopic: {
      is_default: false,
    },
    userLogin: {},
    editedIndex: -1,
    editedItem: {
      topic: "",
      is_default: false,
    },
    defaultItem: {
      name: "",
      username: "",
      telp: "",
      email: "",
      roles: [
        {
          id: "",
          name: "",
        },
      ],
    },

    pageSizes: [10, 50, 100],
    currentPage: 1,
    totalPages: 0,
    pageSize: 10,
    from: 0,
    to: 0,
    totalData: 0,
  }),

  computed: {
    ...mapGetters({
      getUsersUnverified: "user/getUsersUnverified",
      getNotificationTopics: "notification_topic/getNotificationTopics",
    }),

    formTitle() {
      return this.editedIndex === -1 ? "Tambah Topik" : "Edit Topik";
    },
    computedHeaders() {
      let editedHeaders = this.headers;

      return editedHeaders;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    // newTopic: {
    //   handler(val) {
    //     console.log(val.topic);
    //   },
    //   deep: true,
    // },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      storeNotificationTopic: "notification_topic/storeNotificationTopic",
      updateNotificationTopic: "notification_topic/updateNotificationTopic",
      deleteNotificationTopic: "notification_topic/deleteNotificationTopic",
    }),

    parserDateOnly(date) {
      return dayjs(date).format("DD-MM-YYYY");
    },

    copyTestingCode(str) {
      try {
        const el = document.createElement("textarea");
        el.value = str;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);

        this.$notify({
          group: "custom-notification",
          type: "success",
          title: "Success!",
          text: "API Keys was copied!",
        });
      } catch (err) {
        this.$notify({
          group: "custom-notification",
          type: "error",
          title: "Error!",
          text: "Oops! unable to copy",
        });
      }
    },

    async handlePageChange(value) {
      this.topics = this.getNotificationTopics;
      this.currentPage = value;
      const getUsers = await this.dataUsers({
        page: this.currentPage,
        jum: this.pageSize,
      });
      this.totalPages = getUsers.data.attributes.last_page;
      this.currentPage = getUsers.data.attributes.current_page;
      this.from = getUsers.data.attributes.from;
      this.to = getUsers.data.attributes.to;
      this.totalData = getUsers.data.attributes.total;
    },

    async handlePageSizeChange(size) {
      this.topics = [];
      this.pageSize = size;
      this.currentPage = 1;
      const getUsers = await this.dataUsers({
        page: this.currentPage,
        jum: this.pageSize,
      });
      this.totalPages = getUsers.data.attributes.last_page;
      this.currentPage = getUsers.data.attributes.current_page;
      this.from = getUsers.data.attributes.from;
      this.to = getUsers.data.attributes.to;
      this.totalData = getUsers.data.attributes.total;
    },

    async initialize() {
      const getNotificationTopics = await this.getNotificationTopics;
      this.topics = getNotificationTopics;
      this.userLogin = JSON.parse(window.localStorage.getItem("user_data"));
    },

    convertCurrency(total) {
      return "Rp. " + formatCurrency(total);
    },

    editItem(item) {
      this.editedIndex = this.topics.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.newTopic = this.editedItem;
      this.dialog = true;
    },

    async deleteItem(item) {
      const index = this.topics.indexOf(item);

      if (confirm("Are you sure you want to delete this data?")) {
        await this.deleteNotificationTopic(item.id);
        this.topics.splice(index, 1);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.newTopic = {
          is_default: false,
        };
        this.inputSearch = "";
        this.editedItem.name = "";
        this.editedItem.email = "";
        this.editedItem.telp = "";
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      let response;
      try {
        if (this.editedIndex > -1) {
          response = await this.updateNotificationTopic(this.editedItem);
          Object.assign(this.topics[this.editedIndex], response);
          this.$notify({
            group: "custom-notification",
            type: "success",
            title: "Success!",
            text: "Success update User!",
          });
        } else {
          response = await this.storeNotificationTopic(this.newTopic);
        }
        // console.log('response', response)
      } catch (e) {
        console.log(e);
      }
      this.close();
    },

    async generateAPIKey() {
      const result = await this.storeNotificationTopic();
      this.topics.push(result);
    },
  },
};
</script>
<style scoped>
.rounded-circle {
  border-radius: 100%;
  padding: 0 !important;
  min-width: 15px !important;
  box-shadow: none;
}
</style>
